/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': '無標題頁面',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': '建立新頁面並以連結插入',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': '建立 Confluence 頁面',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': '在 Confluence 中開啟',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': '您的頁面已建立',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': '已建立頁面',
  'editorExtensionLinkCreate.confluencePage.title': '建立新頁面',
  'editorExtensionLinkCreate.genericError.description': '請重新整理頁面，然後再試一次。',
  'editorExtensionLinkCreate.genericError.title': '發生錯誤',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description': '建立內嵌議題，並以連結插入',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': '建立 Jira 議題',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': '在 Jira 中開啟',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': '您的議題已建立',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': '已建立議題',
  'editorExtensionLinkCreate.jiraIssue.title': '建立新議題',
  'editorExtensionLinkCreate.keyword.create': '建立',
  'editorExtensionLinkCreate.keyword.issue': '議題',
  'editorExtensionLinkCreate.keyword.new': '新',
  'editorExtensionLinkCreate.keyword.page': '頁面',
  'editorExtensionLinkCreate.keyword.publish': '發佈',
  'editorExtensionLinkCreate.keyword.raise': '提出',
  'editorExtensionLinkCreate.keyword.space': '空間',
  'editorExtensionLinkCreate.keyword.ticket': '工單',
};
